import axiosClient from './axiosClient';

const productService = {
    allProducts: async (filterParams) => {
        const response = await axiosClient.get('/vendor/products', { params: filterParams });
        return response.data;
    },
    getProductDetails: async (productId) => {
        const response = await axiosClient.get(`/vendor/products/${productId}`);
        return response.data.data;
    },
    createProduct: async (payload) => {
        const response = await axiosClient.post('/vendor/products/create', payload);
        return response.data; // includes { success, message, data }
    },
    updateProduct: async (id, payload) => {
        console.log('payload', payload);
        const response = await axiosClient.put(`/vendor/products/${id}`, payload);
        return response.data;
    },

    deleteProduct: async (productId) => {
        const response = await axiosClient.delete(`/vendor/products/${productId}`);
        console.log('Delete response:', response);
        return response.data;
    },

    uploadFile: async (file) => {
        const formData = new FormData();
        formData.append('file', file);
        const response = await axiosClient.post('/file/single', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
            // onUploadProgress: (event) => {
            //     if (onProgress) {
            //         const progress = Math.round((event.loaded * 100) / event.total);
            //         // onProgress(progress);
            //     }
            // }
        });
        return response.data.file; // should contain file URL from backend
    }
};

export default productService;
